import { tv } from "../../variants/tv.js";
const olVariants = tv({
    base: 'list-decimal ps-7',
    variants: {}
});
export { olVariants };
